import { apiClient } from '@/lib/api-client';
import type { MyPerk, MyPlatform } from '../../domain/entities/platform.entity';

export class PlatformsApiDatasource {
  /**
   * Plataformas do usuário logado. A identidade vem do token (nunca da URL), e
   * o back já filtra: só volta o que tem destino configurado e não é a
   * plataforma atual — a atual sai pelo `x-scope-id` que o `apiClient` manda.
   */
  async getMyPlatforms(): Promise<MyPlatform[]> {
    const { data } = await apiClient.get<MyPlatform[]>('/auth/me/platforms');
    return data;
  }

  /** Acessos de UM perfil do próprio usuário. Perfil alheio responde 404. */
  async getProfilePerks(platformProfileId: string): Promise<MyPerk[]> {
    const { data } = await apiClient.get<MyPerk[]>(
      `/me/platform-profiles/${platformProfileId}/perks`,
    );
    return data;
  }
}
